module.exports = __webpack_public_path__ + "img/PART-B-mobile.4cc9303b.png";